import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import AppRoutes from './AppRoutes';

const TRACKING_ID = "G-M7X2PM6D3J"; // Replace with your Google Analytics Measurement ID

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
    ReactGA.send("pageview", { page: location.pathname });
  }, [location]);

  return null;
};

function App() {
  return (
    <Router>
      <Analytics />
        <AppRoutes />
    </Router>
  );
}

export default App;
